import axios from 'axios'
import $store from '@/store/store.js'

const FileOpener = {
	install (Vue, options) {
		Vue.prototype.$FileOpener = {

			fileOpener (mode, path) {
				// mode = show / open
				$store.commit('fileOpenerFallbackChange', {
					visible: true,
					message: null,
					status: 'loading',
					path: path
				})
				return new Promise((resolve, reject) => {
					axios.get('http://localhost:8081/test')
						.then(response => {
							if (response.data) {
								$store.commit('set_fileopener_status', true)
								var data = { mode: mode, path: path }
								var config = {
									headers: { 'content-type': 'application/json' },
									timeout: 5000
								}
								axios.post('http://localhost:8081/open', data, config)
									.then(response => {
										if (!response.data.status) {
											$store.commit('fileOpenerFallbackChange', {
												visible: true,
												message: response.data.message,
												status: null,
												path: path
											})
											reject(new Error(response.data.message))
										} else {
											$store.commit('fileOpenerFallbackChange', {
												visible: false,
												message: null,
												status: null,
												path: null
											})
											resolve(response)
										}
									})
									.catch(error => {
										$store.commit('fileOpenerFallbackChange', {
											visible: true,
											message: error,
											status: null,
											path: path
										})
										reject(error)
									})
							}
						})
						.catch(error => {
							$store.commit('set_fileopener_status', false)
							$store.commit('fileOpenerFallbackChange', {
								visible: true,
								message: `L' utilitaire file opener ne répond pas ...`,
								status: 'notInstalled',
								path: path
							})
							reject(error)
						})
				})
			}

		} // End prototype definition
	} // End Install
} // End plugin

export default FileOpener



// WEBPACK FOOTER //
// ./src/services/fileopener.js